import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartSourceAdjustmentAddDialogComponent } from '../part-source-adjustment-add-dialog/part-source-adjustment-add-dialog.component';
import { DialogData } from '../dialog-data/dialog-data';
import { PartSourceAdjustmentService } from './part-source-adjustment.service';
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from '../global.service';


@Component({
    selector: 'app-part-source-adjustment',
    templateUrl: './part-source-adjustment.component.html',
    styleUrls: ['./part-source-adjustment.component.css'],
    standalone: false
})
export class PartSourceAdjustmentComponent implements OnInit {
  [x: string]: any;

  //Date transform
  pipe = new DatePipe('en-US');
  currentDate = moment().format('DD/MM/YYYY');

  //alertMessage
  errorMessage: string = '';
  successMessage: string = '';


  //ngModel 
  step = 0;
  versionName: any = "";
  namc: any = "";
  family: string = "";
  partNumber: string = "";
  katashiki: any = "";
  status: any = "";
  spinnerMessage = "Please Wait...";
  recordcount: any = 0;
  roleAccess: any = [];
  accessEnable: boolean;
  Roledata: any;
  showdata: boolean = true;
  constructor(private SpinnerService: NgxSpinnerService, private partSourceAdjustmentService: PartSourceAdjustmentService, public dialog: MatDialog, public globalrole: GlobalService,) { }

  //list
  namcLst: any = [];
  versionNameLst: any = [];
  familyLst: any = [];
  partNumberLst: any = [];
  katashikiLst: any = [];
  statusLst: any = [];

  getGridData(data) {
    this.selected=[]
    console.log(this.roleAccess.includes('Read'))
    if (this.roleAccess.includes('Read')) {
      if (this.namc == undefined) {
        this.namc = ""
      }
      if (this.versionName == undefined) {
        this.versionName = ""
      }
      if (this.family == undefined) {
        this.family = ""
      }
      if (this.katashiki == undefined) {
        this.katashiki = ""
      }
      if (this.versionName == undefined) {
        this.versionName = ""
      }
      if (this.partNumber == undefined) {
        this.partNumber = ""
      }
      if (this.status == undefined) {
        this.status = ""
      }
      let gridData =
      {
        namc: this.namc,
        family: this.family,
        partNumber: this.partNumber,
        bomEffectiveFrom: this.bomEffectiveFrom,
        bomEffectiveTo: this.bomEffectiveTo,
        status: this.status,
        versionName: this.versionName,
        katashiki: this.katashiki,
        comments: this.comments,
        option: data

      }
      this.SpinnerService.show();
      this.partSourceAdjustmentService.getGridData(gridData).subscribe(data => {
        console.log(data);
        this.SpinnerService.hide();
        this.showdata = true;
        this.recordcount = data.pagination.totalRecords;
        let datarow = data.payload;
        this.rows = datarow.map(row => ({
          namc_cd: row['namc_cd'],
          fam_cd: row['fam_cd'],
          part_no: row['part_no'],
          bom_eff_dt_from:   (row['bom_eff_dt_from'] == null) ? '' : row['bom_eff_dt_from'].split('T')[0],
          bom_eff_dt_to:(row['bom_eff_dt_to'] == null) ? '' : row['bom_eff_dt_to'].split('T')[0],
          status: row['status'],
          rep_bom_ver_nm: row['rep_bom_ver_nm'],
          katashiki_cd: row['katashiki_cd'],
          rmrk_txt: row['rmrk_txt'],
        }));
        console.log(this.rows)
      }, err => {
        console.log(err);
        this.showdata = false;
        this.successMessage = "";
        console.log(this.showdata);
        this.rows = [];
        if (err == 0) {
          this.errorMessage = "Request timed out. Please try again.";
          this.SpinnerService.hide();
          this.globalrole.goToTop();
        } else {
          this.errorMessage = "No Records";
          this.SpinnerService.hide();
          this.globalrole.goToTop();
        }
      });
    } else {
      this.SpinnerService.hide();
      this.showdata = false;
      console.log(this.showdata);
      this.rows = [];
      this.successMessage = "";
      this.errorMessage = "User does not have permission to perform 'read' operation";
      this.globalrole.goToTop();
    }
  }

  //step for expansion panel
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  resetAll(data) {
    this.selected=[]
    this.namc = '';
    this.versionName = '';
    this.family = '';
    this.katashiki = '';
    this.status = '';
    this.partNumber = '';
    this.errorMessage = '';
    this.successMessage = '';
    this.katashikiLst = [];
    this.familyLst = [];
    // this.getGridData(data);
    this.onloadfn();
  }



  //ngx-datatable
  rows = [];
  SelectionType = SelectionType;
  selected = [];
  isLoading: boolean = false;//loadingIndicator = false;
  reorderable = true;
  @ViewChild('myTable') table;
  limitSelected: any = 50;




  columns = [
    { name: 'namc', prop: 'namc_cd' }, { name: 'family', prop: 'fam_cd' }, { name: 'partNumber', prop: 'part_no' },
    { name: 'bomEffectiveFrom', prop: 'bom_eff_dt_from' }, { name: 'bomEffectiveTo', prop: 'bom_eff_dt_to' },
    { name: 'status', prop: 'status' }, { name: 'versionName', prop: 'rep_bom_ver_nm' }, { name: 'katashiki', prop: 'katashiki_cd' },
    { name: 'comments', prop: 'rmrk_txt' }
  ];
  ColumnMode = ColumnMode;

  ngOnInit(): void {
    (async () => {
      this.SpinnerService.show();
      let a = await this.userroleAccessfn();
      if (a) {
        console.log('a', a)
        //grid
        this.getGridData("initial");
      }
      this.onloadfn();
    })();
  }
  onloadfn(){
    //to get namc
    this.getnamc();
    //to get family on change only
    // this.getfamily();
    this.getversionName();
    this.getStatusData();
    //to get part Number
    this.partSourceAdjustmentService.getPartNumberPsa().subscribe(data => {
      console.log(data);
      this.partNumberLst = data.payload;
    });

  }

  getStatusData() {
    this.partSourceAdjustmentService.getstatusDropdown().subscribe(res => {
      console.log("res from status dropdwon", res);
      this.statusLst = res.payload

    })
  }

  //to get version Name
  getversionName() {
    this.partSourceAdjustmentService.getVersionNamePsa().subscribe(data => {
      console.log(data);
      this.versionNameLst = data.payload;
    });
  }
  //onchange
  getnamc() {
    this.SpinnerService.show()
    if (this.versionName == undefined) {
      this.versionName = ""
    }
    this.partSourceAdjustmentService.getNamcPsa(this.versionName).subscribe(data => {
      console.log(data);
      this.namcLst = data.payload;
      this.SpinnerService.hide()
      this.namc = ""
    },err=>{
      this.SpinnerService.hide()
    });
  }
  //onchange
  getfamily() {
    this.SpinnerService.show()
    if (this.namc == undefined) {
      this.namc = ""
    }
    if (this.versionName == undefined) {
      this.versionName = ""
    }
    if (this.namc != "") {
      this.SpinnerService.show()
      this.partSourceAdjustmentService.getFamilyPsa(this.versionName, this.namc).subscribe(data => {
        console.log(data);
        this.familyLst = data.payload;
        this.SpinnerService.hide()
        this.family = ""
      }, err => {
        this.familyLst = []
        this.SpinnerService.hide()
        this.family = ""
      });
    } else {
      this.familyLst = []
      this.SpinnerService.hide()
      this.family = ""
    }
  }

  // onchange
  getkatashiki() {
    this.SpinnerService.show()
    if (this.namc == undefined) {
      this.namc = ""
    }
    if (this.versionName == undefined) {
      this.versionName = ""
    }
    if (this.family == undefined) {
      this.family = ""
    }
    this.partSourceAdjustmentService.getKatashikiPsa(this.versionName, this.namc, this.family).subscribe(data => {
      console.log(data);
      this.katashikiLst = data.payload;
      this.SpinnerService.hide()
      this.katashiki = ""
    });
  }
  //ngx-table
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    // this.selected.splice(0, this.selected.length);
    // this.selected.push(...selected);
  }

  onActivate(event) {
    // console.log('Activate Event', event);
  }
  displayCheck(row) {
    return row;
  }


  openAddDialog(): void {
    this.errorMessage = '';
    this.successMessage = '';
    if (this.roleAccess.includes('Create')) {
      const dialogRef = this.dialog.open(PartSourceAdjustmentAddDialogComponent, {
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        console.log('The dialog was closed', result);
        if (result == 'success') {
          // this.resetAll('Add')
          this.getGridData("add")
          this.successMessage = "Part source adjustment rule has been added successfully"
          this.selected = []
        }
        else if (result == 'AlreadyExists') {
          this.errorMessage = 'Data Entered already Exists!'
          this.globalrole.goToTop();
        }
        else {
          // this.errorMessage = 'Data not inserted/Valid'
        }
      });
    } else {
      this.errorMessage = "User does not have permission to perform 'create' operation";
      this.globalrole.goToTop();
    }
  }
  search() {
    this.errorMessage = '';
    this.successMessage = ""
    this.getGridData('initial');
  }

  //closealert
  closeAlert() {
    this.errorMessage = "";
    this.successMessage = '';
  }

  userroleAccessfn() {
    return new Promise(resolve => {
      this.globalrole.Roledetails.subscribe(res => {
        console.log(res)
        this.Roledata = res;
      })
      console.log(this.Roledata);
      if (this.Roledata.length != 0) {
        this.Roledata.filter((res) => {
          if (res.function_nm == 'NBPC_10122') {
            this.roleAccess.push(res.access_desc);
          }
        })
        this.accessEnable = true;
        resolve(true);
      } else if (this.Roledata.length == 0) {
        let arrayvalue: any; let roleList: any;
        let data = localStorage.getItem('role');
        arrayvalue = data.split(',')
        console.log(arrayvalue.length, arrayvalue);
        let str = '';
        for (let i = 0; i < arrayvalue.length; i++) {
          if (str == '') {
            str = "'" + arrayvalue[i] + "'"
          } else {
            str += ',' + "'" + arrayvalue[i] + "'";
          }
          roleList = str;
        }
        let body = {
          security_grp_nm: roleList
        }
        let userpreviliagedata=localStorage.getItem('userpreviliagedata')

        if (userpreviliagedata && userpreviliagedata.length!=0 && userpreviliagedata!="") {
        this.globalrole.changeMessage(JSON.parse(userpreviliagedata))
            this.userroleAccessfn();
            this.accessEnable = true;
            resolve(true);
          }
        else {
          console.log(this.roleAccess)
          this.roleAccess = []
          this.errorMessage = "User does not have permission to perform 'read' operation";
          this.accessEnable = false;
          this.SpinnerService.hide();
        }
      }
      console.log(this.roleAccess);
    });
  }
}
